// measurement.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import * as Cesium from 'cesium';

@Injectable({
    providedIn: 'root'
})
export class MeasurementService {
    private isActive = new BehaviorSubject<boolean>(false);
    private currentMeasurement = new BehaviorSubject<any>(null);
    private selectedTool: string = 'ruler';
    private pluginName = 'Measurement Tool';
    private pluginIcon = 'ruler.png';

    constructor() {}

    getPluginName(): string {
        return this.pluginName;
    }

    getPluginIcon(): string {
        return this.pluginIcon;
    }

    initialize(): void {
        // Initialize measurement tool
        this.isActive.next(false);
        this.currentMeasurement.next(null);
    }

    open(): void {
        this.isActive.next(true);
    }

    close(): void {
        this.isActive.next(false);
        this.currentMeasurement.next(null);
    }

    // startMeasurement(): void {
    //     this.isActive.next(true);
    // }

    // stopMeasurement(): void {
    //     this.isActive.next(false);
    //     this.currentMeasurement.next(null);
    // }

    // setCurrentMeasurement(measurement: any): void {
    //     this.currentMeasurement.next(measurement);
    // }

    // getIsActive(): Observable<boolean> {
    //     return this.isActive.asObservable();
    // }

    // getCurrentMeasurement(): Observable<any> {
    //     return this.currentMeasurement.asObservable();
    // }

    // getSelectedTool(): string {
    //     return this.selectedTool;
    // }

    // setSelectedTool(tool: string): void {
    //     this.selectedTool = tool;
    // }
}